import React from 'react';
import * as HostSelectors from 'redux/reducers/gl_host_provider/selectors';
import HostActions from 'redux/reducers/gl_host_provider/actions';
import { useDispatch } from 'react-redux';
import { StateStatus } from 'redux/utils/common';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';
import ThemeActions from 'redux/reducers/gl_theme_reducer/actions';
import { ThemesModeEnum } from 'config';
import _ from 'lodash';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';

interface IDomainConfigProviderProps {
  children: React.ReactNode;
}

// https://stackoverflow.com/questions/11401897/get-the-current-domain-name-with-javascript-not-the-path-etc

const HostProvider = ({ children }: IDomainConfigProviderProps) => {
  // const domain = window.location.hostname;
  const dispatch = useDispatch();
  const hostDetails = HostSelectors.useHostDetails();
  // const isLogin = AuthSelectors.useSelectIsLogin();

  React.useEffect(() => {
    // if (isLogin) {
    //   dispatch(HostActions.fetchHostDetailsAction());
    // }
    dispatch(HostActions.fetchHostDetailsAction());
  }, [dispatch]);

  React.useLayoutEffect(() => {
    const logoid = hostDetails.data?.settings?.['cellock.theme.logoId'];
    const navigationType =
      hostDetails.data?.settings?.['cellock.theme.navigationType'];
    // _.get(
    //   hostDetails.data?.settings,
    //   'theme.navigationType'
    // );
    const palleteId = hostDetails.data?.settings?.['cellock.theme.palleteId'];
    //  _.get(hostDetails.data?.settings, 'theme.palleteId');
    const darkMode = hostDetails.data?.settings?.['cellock.theme.darkMode'];
    // _.get(hostDetails.data?.settings, 'theme.darkMode');

    if (logoid) {
    }
    if (navigationType) {
      dispatch(NavigationActions.setNavbarTypeAction(navigationType as any));
    }
    if (palleteId) {
      dispatch(ThemeActions.setPalleteIdAction(palleteId as any));
    }
    dispatch(
      ThemeActions.changeThemeAction(
        darkMode === 'True' ? ThemesModeEnum.Dark : ThemesModeEnum.Light
      )
    );
  }, [hostDetails, dispatch]);

  return (
    <React.Fragment>
      {hostDetails.status !== StateStatus.Pending && children}
    </React.Fragment>
  );
};

export default React.memo(HostProvider);
